<template>
    <Select v-model="selected" @on-change="onChange" size="small">
        <Option v-for="item in options" :key="item.value" :value="item.value">{{item.label}}</Option>
    </Select>
</template>
<script>
    export default {
        props: ["value"],
        data() {
            return {
                selected: '',
                options: [{
                    label: "全国省份",
                    value: "ChinaProvince"
                }, {
                    label: "北京区县",
                    value: "BeiJingCounty"
                }, {
                    label: "京津冀城市群",
                    value: "jingjinjiCitys"
                }, {
                    label: "京津冀区县群",
                    value: "jingjinjiCounty"
                }],
                mapConfig: {
                    "ChinaProvince": {
                        lng: "105.2141942496418",
                        lat: "38.32113002834947",
                        zoom: 5,
                        api: "../default-data/polygon-count-data.json"
                    },
                    "BeiJingCounty": {
                        lng: "116.35375748889481",
                        lat: "40.07463861474714",
                        zoom: 9,
                        api: "../default-data/polygon-BeiJingCounty-data.json"
                    },
                    "jingjinjiCitys": {
                        lng: "115.76159449671735",
                        lat: "39.7754005208003",
                        zoom: 8,
                        api: "../default-data/polygon-jingjinjiCitys-data.json"
                    },
                    "jingjinjiCounty": {
                        lng: "115.63741274301799",
                        lat: "39.622619685225",
                        zoom: 8,
                        api: "../default-data/polygon-jingjinjiCounty-data.json"
                    }
                }
            }
        },
        watch: {
            'value': {
                handler() {
                    this.selected = this.value;
                },
                immediate: true
            }
        },
        methods: {
            onChange() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    // this.$emit('input', this.selected);
                    const config = this.mapConfig[this.selected];
                    console.log('prop', this.selected)
                    if (config) {
                        this.$emit('updateVal', {
                            ...config,
                            name: this.selected
                        });
                    }
                    this.$emit('save')
                }, 1000);
            }
        },
    }
</script>